<ng-container *transloco="let t">
  <div class="p-mt-4">
    <p-table [value]="days" [paginator]="false" styleClass="p-datatable-sm">

      <ng-template pTemplate="header">
        <ng-template *ngIf="type === AppointmentCalendarType.Dates" [ngTemplateOutlet]="dateHeader"></ng-template>
        <ng-template *ngIf="type === AppointmentCalendarType.Availabilities" [ngTemplateOutlet]="appointmentHeader"></ng-template>
      </ng-template>

      <ng-template pTemplate="body" let-day>
        <ng-template *ngIf="type === AppointmentCalendarType.Dates" [ngTemplateOutlet]="dateContent" [ngTemplateOutletContext]="{ day: day }"></ng-template>
        <ng-template *ngIf="type === AppointmentCalendarType.Availabilities" [ngTemplateOutlet]="appointmentContent" [ngTemplateOutletContext]="{ day: day }"></ng-template>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="no-data" [attr.colspan]="(type === AppointmentCalendarType.Availabilities) ? 10 : 4">{{ t('common.texts.no_entries') }}</td>
        </tr>
      </ng-template>

    </p-table>
  </div>

  <ng-template #dateHeader>
    <tr>
      <th>{{ t('common.labels.date') }}</th>
      <th>{{ t('common.labels.type') }}</th>
      <th style="width: 60%;">{{ t('common.labels.name') }}</th>
      <th></th>
    </tr>

  </ng-template>

  <ng-template #appointmentHeader>
    <tr>
      <th>{{ t('common.labels.date') }}</th>
      <th>{{ t('common.labels.details') }}</th>
      <th>{{ t('common.labels.status') }}</th>
      <th>{{ t('common.labels.name') }}</th>
      <th>{{ t('common.labels.language') }}</th>
      <th>{{ t('common.labels.time') }}</th>
      <th>{{ t('common.labels.location') }}</th>
      <th>{{ t('common.labels.moderator') }}</th>
      <th>{{ t('common.labels.id') }}</th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template #dateContent let-day="day">
    <tr>
      <td>{{ day.day | amDateFormat: 'DD.MM.Y' }}</td>
      <td>{{ t('common.labels.' + day.type) }}</td>
      <td>
        {{ day.getHolidayName() }}
        <span *ngIf="day.data?.holiday?.states !== null" class="statelist">({{ day.getHolidayStates().join(', ') }})</span>
      </td>
      <td class="p-text-right"><i *ngIf="inEdit === true" class="pi pi-trash pointer" (click)="onDeleteDay(day)"></i></td>
    </tr>
  </ng-template>

  <ng-template #appointmentContent let-day="day">
    <ng-container *ngIf="!day.hasAcs()">
      <tr>
        <td>{{ day.day | amDateFormat: 'DD.MM.Y' }}</td>
        <td>{{ day.getDataList(locations) }}</td>
        <td>{{ t('common.labels.' + day.status) }}</td>
        <td colspan="6"></td>
        <td class="p-text-right"><i *ngIf="inEdit === true" class="pi pi-trash pointer" (click)="onDeleteDay(day)"></i></td>
      </tr>
    </ng-container>
    <ng-container *ngIf="day.hasAcs()">
      <tr *ngFor="let ac of day.acs; let i = index">
        <td><ng-container *ngIf="i === 0">{{ day.day | amDateFormat: 'DD.MM.Y' }}</ng-container></td>
        <td><ng-container *ngIf="i === 0">{{ day.getDataList(locations) }}</ng-container></td>
        <td>{{ t('common.labels.' + ac.status) }}</td>
        <td>{{ ac.name }}</td>
        <td>{{ t('common.languages.' + ac.language) }}</td>
        <td>{{ ac.start | amLocal | amDateFormat: 'HH:mm' }} - {{ ac.end | amLocal | amDateFormat: 'HH:mm' }} {{ t('common.labels.oclock') }}</td>
        <td>{{ ac.location }}</td>
        <td>{{ ac.moderator }}</td>
        <td>{{ ac.ordernumber }}</td>
        <td></td>
      </tr>
    </ng-container>
  </ng-template>

</ng-container>
